import EventActivityVue from '@/views/sm/event-activity/event-activity.vue';

const basePath = '/sm/event-activity';
const role = 'sm'; // 角色身份

export const SM_EVENT_ACTIVITY_RESERVATION_EDIT = 'sm-event-activity-reservation-edit';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/edit`,
  component: EventActivityVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/edit/:id`,
      name: SM_EVENT_ACTIVITY_RESERVATION_EDIT,
      props: true,
      component: () => import(
        /* webpackChunkName: "chatRoom" */
        `@/views/${role}/event-activity/edit.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
